module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/rectangle-path-119fb78ed8c9f9716d0065105d60a841.svg";